import { render, staticRenderFns } from "./QueueCommands.vue?vue&type=template&id=66ae3d90&scoped=true"
import script from "./QueueCommands.vue?vue&type=script&lang=ts"
export * from "./QueueCommands.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ae3d90",
  null
  
)

export default component.exports